import { motion } from 'motion/react';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const OptionItemSquareWithIconListStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 12px;
  padding: 0 16px;
`;

export const OptionItemSquareWithIconStyles = styled(motion.div)<{
  isSelected: boolean;
}>`
  body.dark & {
    --bg-color: #765279;
    --bg-color-selected: #ffc9fb;
  }

  --square-with-icon-width: 166px;
  --bg-color: #ffffff80;
  --bg-color-selected: #ece4fd;
  background: var(--bg-color);
  box-sizing: border-box;
  width: var(--square-with-icon-width);
  aspect-ratio: 1.1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 20px 12px;
  border-radius: 16px;

  @media screen and (max-width: 380px) {
    --square-with-icon-width: 130px;
  }

  ${({ isSelected }) => isSelected && 'background: var(--bg-color-selected);'}
`;

export const OptionItemSquareWithIconTitleStyles = styled(UiTypography)<{
  isSelected: boolean;
}>`
  margin: 8px 0 0;

  ${({ isSelected }) => {
    if (isSelected) {
      return `
            color: #171123;
        `;
    }
  }}
`;
